import React, { useEffect } from 'react';
import { Helpers } from '@shared/utils/Helpers';

const BeginUnsubscribe = () => {
  useEffect(() => {
    let redirectURL = `https://unsubscribe.360vuz.com/`;
    let userId = Helpers.getUrlParameter('userId');

    if (userId) {
      redirectURL = `${redirectURL}${userId}`;
    }

    window.location.href = redirectURL;
  }, []);

  return <div></div>;
};

export { BeginUnsubscribe };
